import { DataModel } from "common/models/utility-models/base-model";

export class AlumniModel extends DataModel {
    profile_pic_path: any;
    first_name: string = '';
    last_name: string = '';
    mobile_number: string = '';
    email: string = '';
    gender: string = '';
    branch_name: string = null;
    branch_id:number = null;
    name_of_college: string = '';
    college_address: string = '';
    company_name: '';
    company_location: '';
    company_designation: '';
    placement_company_name:string='';
    placement_company_location:string='';
    placement_company_designation:string='';
    other: any;


}

export class alumniForm {
    mobile_number: '';
    email: '';
    address: '';
    gender: '';
    profile_pic_path: '';
    company_name: '';
    company_location: '';
    company_designation: '';
    other: any;

  }